angular
    .module('app', ['ngMaterial', 'ngSanitize', 'ngRoute', 'md.data.table', 'ngFileUpload', 'angularLazyImg' , 'ngCookies', 'ngWig', angularDragula(angular)])
    .config(function($mdThemingProvider, $mdIconProvider, $routeProvider, $httpProvider, $sceDelegateProvider, $cookiesProvider, $compileProvider) {
        $cookiesProvider.defaults.path = '/';

        $mdThemingProvider.theme('default').primaryPalette('purple', {
            'default': '500'
        });

        $mdIconProvider.icon('schools', '/static/images/schools.svg');
        $mdIconProvider.icon('events', '/static/images/events.svg');
        $mdIconProvider.icon('subjects', '/static/images/subjects.svg');
        $mdIconProvider.icon('communication', '/static/images/communication.svg');
        $mdIconProvider.icon('customers', '/static/images/customers.svg');
        $mdIconProvider.icon('orders', '/static/images/orders.svg');
        $mdIconProvider.icon('lab-orders', '/static/images/lab-orders.svg');
        $mdIconProvider.icon('templates', '/static/images/templates.svg');
        $mdIconProvider.icon('price-lists', '/static/images/price-lists.svg');
        $mdIconProvider.icon('coupons', '/static/images/coupons.svg');
        $mdIconProvider.icon('franchise', '/static/images/franchise.svg');
        $mdIconProvider.icon('expenses', '/static/images/expenses.svg');
        $mdIconProvider.icon('leads', '/static/images/leads.svg');
        $mdIconProvider.icon('products', '/static/images/products.svg');
        $mdIconProvider.icon('incentives', '/static/images/incentives.svg');
        $mdIconProvider.icon('moods', '/static/images/moods.svg');
        $mdIconProvider.icon('territories', '/static/images/territories.svg');
        $mdIconProvider.icon('session-types', '/static/images/session-types.svg');
        $mdIconProvider.icon('reports', '/static/images/reports.svg');
        $mdIconProvider.icon('grid-on', '/static/images/grid-on.svg');
        $mdIconProvider.icon('watch-later', '/static/images/watch-later.svg');
        $mdIconProvider.icon('breadcrumb-arrow', '/static/images/icon_arrow.svg');
        $mdIconProvider.icon('save', '/static/images/save.svg');
        $mdIconProvider.icon('help', '/static/images/help.svg');
        $mdIconProvider.icon('accordion-incentives', '/static/images/incentives.svg');
        $mdIconProvider.defaultIconSet('/static/images/event-icons.svg', 24);

        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'https://storage.googleapis.com/**'
        ]);

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|ical):/);

        $routeProvider
            .when('/school', {'templateUrl': 'schools.html', 'controller': 'SchoolsCtrl', 'controllerAs': 'main'})
            .when('/school/:id', {'templateUrl': 'school.html', 'controller': 'SchoolCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/event', {'templateUrl': 'events.html', 'controller': 'EventsCtrl', 'controllerAs': 'main'})
            .when('/event/:id', {'templateUrl': 'events/event.html', 'controller': 'EventCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/event/:event_id/import-photos', {'templateUrl': 'import-photos.html', 'controller': 'ImportPhotosCtrl', 'controllerAs': 'main'})
            .when('/event/:id/class-photos', {'templateUrl': 'class-photos.html', 'controller': 'ClassPhotosCtrl', 'controllerAs': 'main'})
            .when('/event/:id/pspa', {'templateUrl': 'pspa-preview.html', 'controller': 'PspaCtrl', 'controllerAs': 'main'})
            .when('/event/:id/pspa/file-copy', {'templateUrl': 'pspa-file-copy.html', 'controller': 'PspaFileCopyCtrl', 'controllerAs': 'main', 'resolve': { 'mode': function() { return 'pspa'; }}})
            .when('/file-copy', {'templateUrl': 'pspa-file-copy.html', 'controller': 'PspaFileCopyCtrl', 'controllerAs': 'main', 'resolve': { 'mode': function() { return 'generic'; }}})
            .when('/orb_order/:id', {'templateUrl': 'orb.html', 'controller': 'OrbCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/orb_order', {'templateUrl': 'orb_orders.html', 'controller': 'OrbOrdersCtrl', 'controllerAs': 'main'})
            .when('/subject', {'templateUrl': 'subjects.html', 'controller': 'SubjectsCtrl', 'controllerAs': 'main'})
            .when('/subject/:id', {'templateUrl': 'subject.html', 'controller': 'SubjectCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/subject/:id/photos', {'templateUrl': 'manage-photos.html', 'controller': 'ManagePhotosCtrl', 'controllerAs': 'main'})
            .when('/franchise', {'templateUrl': 'franchises.html', 'controller': 'FranchisesCtrl', 'controllerAs': 'main'})
            .when('/franchise/:id', {'templateUrl': 'franchise.html', 'controller': 'FranchiseCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/mood', {'templateUrl': 'moods.html', 'controller': 'MoodsCtrl', 'controllerAs': 'main'})
            .when('/mood/:id', {'templateUrl': 'mood.html', 'controller': 'MoodCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/photo', {'templateUrl': 'photos.html', 'controller': 'PhotosCtrl', 'controllerAs': 'main'})
            .when('/photo/:id', {'templateUrl': 'photo.html', 'controller': 'PhotoCtrl', 'controllerAs': 'main'})
            .when('/template', {'templateUrl': 'templates.html', 'controller': 'TemplatesCtrl', 'controllerAs': 'main'})
            .when('/template/:id', {'templateUrl': 'template.html', 'controller': 'TemplateCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/product', {'templateUrl': 'products.html', 'controller': 'ProductsCtrl', 'controllerAs': 'main'})
            .when('/product/:id', {'templateUrl': 'product.html', 'controller': 'ProductCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/price-list', {'templateUrl': 'price-lists.html', 'controller': 'PriceListsCtrl', 'controllerAs': 'main'})
            .when('/price-list/:id', {'templateUrl': 'price-list.html', 'controller': 'PriceListCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/coupon', {'templateUrl': 'coupons.html', 'controller': 'CouponsCtrl', 'controllerAs': 'main'})
            .when('/coupon/:id', {'templateUrl': 'coupon.html', 'controller': 'CouponCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/incentive', {'templateUrl': 'incentives.html', 'controller': 'IncentivesCtrl', 'controllerAs': 'main'})
            .when('/incentive/:id', {'templateUrl': 'incentive.html', 'controller': 'IncentiveCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/order', {'templateUrl': 'orders.html', 'controller': 'OrdersCtrl', 'controllerAs': 'main'})
            .when('/order/:id', {'templateUrl': 'order.html', 'controller': 'OrderCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/customer', {'templateUrl': 'customers.html', 'controller': 'CustomersCtrl', 'controllerAs': 'main'})
            .when('/customer/:id', {'templateUrl': 'customer.html', 'controller': 'CustomerCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/communication', {'templateUrl': 'communications.html', 'controller': 'CommunicationsCtrl', 'controllerAs': 'main'})
            .when('/communication/:id', {'templateUrl': 'communication.html', 'controller': 'CommunicationCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/leads', {'templateUrl': 'leads.html', 'controller': 'LeadsCtrl', 'controllerAs': 'main'})
            .when('/session-type', {'templateUrl': 'session-types.html', 'controller': 'SessionTypesCtrl', 'controllerAs': 'main'})
            .when('/territory', {'templateUrl': 'territories.html', 'controller': 'TerritoriesCtrl', 'controllerAs': 'main'})
            .when('/territory/:id', {'templateUrl': 'territory.html', 'controller': 'TerritoryCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/user/:id', {'templateUrl': 'user.html', 'controller': 'UserCtrl', 'controllerAs': 'main', 'pageHeader': true})
            .when('/expense', {'templateUrl': 'expenses.html', 'controller': 'ExpensesCtrl', 'controllerAs': 'main'})
            .when('/report', {'templateUrl': 'reports.html', 'controller': 'ReportCtrl', 'controllerAs': 'main', 'reloadOnSearch': false})
            .when('/calendars', {'templateUrl': 'calendars.html'})
            .when('/', {'redirectTo': '/event'});


        var errorHandler = function($q, $rootScope) {
            return {
                'response': function(response) {
                    return response || $q.when(response);
                },
                'responseError': function(rejection) {
                    console.log(rejection);
                    if(rejection.status == 403) {
                        if(rejection.data.message != 'Please login') {
                            $rootScope.showHttpError(rejection);
                        } else {
                            if($rootScope.isApp && $rootScope.ezgo.reauth) {
                                $rootScope.ezgo.reauth();
                            }
                            if(!$rootScope.loginShown) {
                                $rootScope.loginShown = true;
                                $rootScope.showLogin();
                            }
                        }
                    } else {
                        $rootScope.showHttpError(rejection);
                    }
                    return $q.reject(rejection);
                }
            };
        };

        $httpProvider.interceptors.push(errorHandler);
    })
    .run(function($rootScope, $mdDialog, $location, $mdToast, appUtils, $http, $cookies, $route, $interval) {
        "ngInject";
        var mobileBreakpoint = window.matchMedia('(max-width: 1279px)');

        $rootScope.menuOpen = !mobileBreakpoint.matches;

        mobileBreakpoint.addListener(function(e) {
            $rootScope.$apply(function() {
                $rootScope.menuOpen = !e.matches;
            });
        });

        $rootScope.$on('$routeChangeSuccess', function(event, current) {
            $rootScope.showPageHeader = !!(current && current.$$route && current.$$route.pageHeader);
            $rootScope.isEventDetailPage = !!(current && current.$$route && current.$$route.templateUrl === 'events/event.html');

            if (mobileBreakpoint.matches) {
                $rootScope.menuOpen = false;
            }
        });

        if(window.ezgo) {
            $rootScope.isApp = true;
            $rootScope.ezgo = window.ezgo;

            window.addEventListener('message', function(event) {
                if(event.data && event.data.type) {
                    console.log(event.data);
                    $rootScope.$broadcast(`ezgo-app:${event.data.type}`, event.data);
                }
            });
        } 
        
        $rootScope.previewUrl = 'https://us-central1-spoiled-rotten.cloudfunctions.net/adminPreview'
        $rootScope.util = appUtils;

        $rootScope.initDate = new Date();

        $rootScope.late_count = 0;
        $rootScope.overdue_count = 0;

        $rootScope.updateCounts = function() {
            if($rootScope.is_superadmin || $rootScope.is_owner || $rootScope.orders_access) {
                var params = {
                    'is_list': true,
                    'results_per_page': 0,
                    'page': 1,
                    'q': {
                        'filters': [{"name":"sent_to_lab","op":"eq","val":false},{"name":"late_orders","op":"eq","val":true}]
                    }
                };
                $http({'method': 'GET', 'url': '/api/v1/admin/orders', 'params': params}).then(
                    function(response) {
                        $rootScope.late_count = response.data.num_results;
                    }
                );
            }

            if($rootScope.is_superadmin || $rootScope.is_owner || $rootScope.events_access) {
                $http({'method': 'GET', 'url': '/api/v1/admin/deliverable/overdue-count'}).then(
                    function(response) {
                        $rootScope.overdue_count = response.data;
                    }
                );
            }
        }
        $interval($rootScope.updateCounts, 1000*60*10);

        $rootScope.loadSessionTypes = function() {
            $http({
                'method': 'GET',
                'url': '/api/v1/admin/session_set',
                'params': { 'results_per_page': 1000, 'q': {"order_by":[{"field":"session_type","direction":"asc"},{"field":"name","direction":"asc"}]}}
            }).then((response) => {
                $rootScope.session_types = response.data.objects.reduce((acc, session) => {
                    if (!acc[session.session_type]) {
                        acc[session.session_type] = [];
                    }
                    acc[session.session_type].push(session);
                    return acc;
                }, {});
            });
        }
        $rootScope.$on('loggedIn', $rootScope.loadSessionTypes);


        $rootScope.recipient_groups = [
            'All Subjects',
            'Everyone who ordered',
            'Everyone who ordered (Home Ship)',
            'Everyone who ordered (Non-Home Ship)',
            'Everyone who did not order',
            'Everyone who has not viewed their gallery',
            'School Contact',
            'Send to Individuals'
        ]

        $rootScope.isMenuActive = function(url) {
            return $location.path().startsWith(url);
        };

        $rootScope.updateViewGlobal = function() {
            $cookies.put('viewGlobal', $rootScope.viewGlobal);
            $route.reload();
        };
        
        $rootScope.viewGlobal = $cookies.get('viewGlobal');

        $rootScope.showHttpError = function(rejection) {
            var message = rejection.data.message || "There was an error processing your request: " + rejection.statusText;
            var alert = $mdToast.simple({'hideDelay': 0}).theme('error-toast').action('DISMISS').textContent(message);
            $mdToast.show(alert);
        };

        $rootScope.savePermissions = function(data) {
            $rootScope.user_id = data.user_id;
            $rootScope.franchise_id = data.franchise_id;
            $rootScope.franchise_name = data.franchise_name
            $rootScope.original_franchise_name = data.franchise_name
            $rootScope.is_superadmin = data.is_superadmin;
            $rootScope.report_access = data.report_access;
            $rootScope.stats_access = data.stats_access;
            $rootScope.photographer_report_access = data.photographer_report_access;

            $rootScope.schools_access = data.schools_access;
            $rootScope.events_access = data.events_access;
            $rootScope.subjects_access = data.subjects_access;
            $rootScope.communications_access = data.communications_access;
            $rootScope.customers_access = data.customers_access;
            $rootScope.orders_access = data.orders_access;
            $rootScope.lab_orders_access = data.lab_orders_access;
            $rootScope.templates_access = data.templates_access;
            $rootScope.price_lists_access = data.price_lists_access;
            $rootScope.products_access = data.products_access;
            $rootScope.coupons_access = data.coupons_access;
            $rootScope.moods_access = data.moods_access;

            $rootScope.is_owner = data.is_owner;
            $rootScope.email = data.email;
            $rootScope.firstName = data.firstName;
            $rootScope.lastName = data.lastName;
            $rootScope.$broadcast('permissions-saved');

            var viewFranchiseId = $cookies.get('viewFranchiseId');
            if(viewFranchiseId) {
                $http({
                    'url': '/api/v1/admin/franchise/' + viewFranchiseId,
                    'method': 'GET',
                }).then(
                    function(response) {
                        $rootScope.franchise_name = response.data.name;
                    }
                );
            }
        };

        $rootScope.logout = function() {
            $http({'method': 'DELETE', 'url': '/api/v1/admin/login'}).then(function(response) {
                if(!$rootScope.loginShown) {
                    $rootScope.loginShown = true;
                    $rootScope.showLogin();
                }
            });
        };

        $http.get('/api/v1/admin/login').then(function(response) {
            $rootScope.savePermissions(response.data);
            $rootScope.updateCounts();
            $rootScope.loadSessionTypes();
        });
        
        $rootScope.franchiseSwitcher = {
            'eqFields': [],
            'query': { },
            'load': function($scope) {
                var viewFranchiseId = $rootScope.franchiseSwitcher.query.franchise_id;
                if($scope.selectedItem) {
                    $rootScope.franchise_name = $scope.selectedItem.name;
                } else {
                    $rootScope.franchise_name = $rootScope.original_franchise_name;
                }
                if(viewFranchiseId) {
                    $cookies.put('viewFranchiseId', viewFranchiseId);
                } else {
                    $cookies.remove('viewFranchiseId');
                }
                $route.reload();
            },
            'activeFranchise': function() {
                var viewFranchiseId = $rootScope.franchiseSwitcher.query.franchise_id;
                if(viewFranchiseId) {
                    return viewFranchiseId;
                } else {
                    return $rootScope.franchise_id;
                }
            }
        };

        var viewFranchiseId = $cookies.get('viewFranchiseId');
        if(viewFranchiseId) {
            $rootScope.franchiseSwitcher.query.franchise_id = viewFranchiseId;
        }

        $rootScope.showLogin = function() {
            $mdDialog.show({
                'controller': 'LoginCtrl',
                'controllerAs': 'main',
                'escapeToClose': false,
                'templateUrl': 'login.html',
                'multiple': true
            });
        };

        $rootScope.openCalendar = function($event) {
            top.location = $rootScope.calendarURL;
        };

        $rootScope.default_deliverables = {
            'Deliver Marketing Materials': {'due': 'marketing_due_date', 'complete': 'marketing_material_delivered'},
            'Send Electronic Marketing': {'due': 'marketing_due_date', 'complete': 'electronic_marketic_done'},
            'Post Proofs': {'due': 'expected_post_date', 'complete': 'proofs_posted'},
            'Send to Lab': {'complete': 'sent_to_lab'},
            'Deliver to School': {'due': 'expected_delivery_date', 'complete': 'delivered_to_school'},
        }

        $rootScope.isDefaultDeliverable = function(deliverable) {
            if(deliverable.name == '') {
                return false;
            }
            return (deliverable.name in $rootScope.default_deliverables);
        }

        $rootScope.CLASS_NAME_QUESTION_ID = 1;

        $rootScope.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) { return { abbrev: state }; });
    });
